import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
  static readonly targets = ['radio', 'target'];

  declare radioTargets: HTMLInputElement[];
  declare targetTargets: HTMLFieldSetElement[];

  get currentId() {
    for (const radio of this.radioTargets) {
      if (radio.checked) {
        return radio.value;
      }
    }
    return undefined;
  }

  initialize() {
    for (const radio of this.radioTargets) {
      radio.addEventListener('change', this.handleToggle);
    }

    this.handleToggle();
  }

  handleToggle = () => {
    const id = this.currentId;

    for (const target of this.targetTargets) {
      if (target.id === id) {
        this.show(target);
      } else {
        this.hide(target);
      }
    }
  };

  show(element: HTMLFieldSetElement) {
    element.hidden = false;
    element.disabled = false;
  }

  hide(element: HTMLFieldSetElement) {
    element.hidden = true;
    element.disabled = true;
  }
}
